/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:04
 * @Description: 指令入口
 */

export const registerDirectives = (Vue) => {
	// 这里注册你的全局指令
};
